import { useState } from 'react';

/**
 * Which subtasks are ticked in a list (spec 137 US3). `available` is what the
 * list shows now: a tick whose task has since left it (moved, deleted) stops
 * counting, so the move button never offers a stale id (FR-020).
 */
export function useSubtaskSelection(available: readonly string[]) {
  const [picked, setPicked] = useState<ReadonlySet<string>>(new Set());
  const selected = new Set([...picked].filter((id) => available.includes(id)));

  const toggle = (id: string) =>
    setPicked((current) => {
      const next = new Set(current);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  const clear = () => setPicked(new Set());

  return { selected, toggle, clear };
}
